export default __webpack_public_path__ + "static/media/Screenshot 2022-05-30 at 5.03.24 PM.8b79f622.png";